const message = {
  departments: "Departments",
  pathologiesMostConsulted: "Most consulted <br>pathologies",
  institution: "Institution",
  followUs: "Follow Us",
  allRightsReserved: "All Rights Reserved",
  aboutIncocegla: "About Incocegla",
  glaucomaClub: "Glaucoma Club",
  incoceglaFoundation: "Incocegla Foundation",
};
export default message;
